import CustomCard from "components/CustomCard/CustomCard";
import Trend1 from "assets/images/Trend1.png";
import RL1 from "assets/images/temp/RL1.png";
import RL2 from "assets/images/temp/RL2.png";

export default function NewsAndTrends() {

  return (
    <div className="widget">
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">News & Trends</h3>

        <button className="btn btn-flat text-white flex-center">
          View Report
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      {/* Header */}

      <h6 className="text-gray-400 fw-300">
        <small className="text-gray-500 ml-1">Description</small>
      </h6>

      <div className="row mv-3">
        <div className="col-12 mb-4" style={{ height: '20rem' }}>
          <CustomCard
            img={Trend1}
            title="Security comes first in U.S.-China economic relations, says Treasury Secretary Yellen"
            content="Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures."
            position="start"
          />
        </div>
        <div className="col-6">
          <CustomCard
            img={RL1}
            title="McCarthy proposes changing access to food stamps as part of debt limit debate"
            content="Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures."
            position="start"
          />
        </div>
        <div className="col-6">
          <CustomCard
            img={RL2}
            title="Timing of call between Xi and Ukrainian President Zelensky suggests there are more drivers than just peace in China’s calculus"
            content="Supply chains will be disrupted based on ongoing geopolitical crisis, Covid, and inflationary pressures."
            position="start"
          />
        </div>
      </div>

    </div>
  );
}
